import { FormGroup, FormControl, Validators } from '@angular/forms';

import { BocOpt, Need4SteelOffer, DEFAULT_TRANSPORT_MODE, DEFAULT_INCOTERM } from './need4steel';

export class FormNeed4SteelOffer extends FormGroup {
	private lastSoldTo: string | undefined;
	private lastShipTo: string | undefined;
	private lastPayer: string | undefined;
	private offerId: number | undefined;
	private externalOfferId: string | undefined;
	constructor() {
		super({
			coNbr: new FormControl(undefined, Validators.compose([
				Validators.required,
				Validators.maxLength(32),
				Validators.pattern('^.*[^ ]+$')
			])),
			soldTo: new FormControl(undefined, Validators.required), // businessId: string
			shipTo: new FormControl(undefined, Validators.required), // businessId: string
			endUser: new FormControl(undefined, Validators.required), // businessId: string
			payer: new FormControl(undefined),
			deliveryDate: new FormControl(undefined),
			mill: new FormControl(undefined),
			weightType: new FormControl('maxNetWeightValue', { nonNullable: true }),
			tmode: new FormControl(DEFAULT_TRANSPORT_MODE, { nonNullable: true }),
			incoterm: new FormControl(DEFAULT_INCOTERM, { nonNullable: true })
		});
	}

	getAndUpdateLastBoc(newBoc: BocOpt) {
		const soldTo = this.lastSoldTo;
		this.lastSoldTo = newBoc.soldTo;
		const shipTo = this.lastShipTo;
		this.lastShipTo = newBoc.shipTo;
		const payer = this.lastPayer;
		this.lastPayer = newBoc.payer;
		return { soldTo, shipTo, payer };
	}

	getOfferId() {
		return this.offerId;
	}

	setOfferId(offerId: number) {
		this.offerId = offerId;
	}

	getExternalOfferId() {
		return this.externalOfferId;
	}

	setExternalOfferId(externalOfferId: string) {
		this.externalOfferId = externalOfferId;
	}

	getFormCoNbr() {
		return <FormControl> this.get('coNbr');
	}

	getFormSoldTo() {
		return <FormControl> this.get('soldTo');
	}

	getFormShipTo() {
		return <FormControl> this.get('shipTo');
	}

	getFormEndUser() {
		return <FormControl> this.get('endUser');
	}

	getFormPayer() {
		return <FormControl> this.get('payer');
	}

	getFormDeliveryDate() {
		return <FormControl> this.get('deliveryDate');
	}

	getFormMill() {
		return <FormControl> this.get('mill');
	}

	getFormWeightType() {
		return <FormControl> this.get('weightType');
	}

	getFormTmode() {
		return <FormControl> this.get('tmode');
	}

	getFormIncoterm() {
		return <FormControl> this.get('incoterm');
	}

	isOfferHeaderValid() {
		return this.getFormCoNbr().valid
			&& this.getFormSoldTo().valid
			&& this.getFormShipTo().valid
			&& this.getFormEndUser().valid;
	}

	setMillOffer(offer: Need4SteelOffer) {
		const { header } = offer;
		this.offerId = header.id;
		this.externalOfferId = header.externalId;
		this.getFormCoNbr().setValue(header.coNbr);
		this.lastSoldTo = header.soldTo;
		this.getFormSoldTo().setValue(header.soldTo);
		this.lastShipTo = header.shipTo;
		this.getFormShipTo().setValue(header.shipTo);
		this.lastPayer = header.payer;
		this.getFormPayer().setValue(header.payer);
		return this;
	}
}
